import { downloadInfoSchema as N } from "../../deserializes/yup/download.js";
import s from "../../../temp-lib/config/index.js";
import { AssetType as O } from "../../../temp-lib/constants/url.js";
import { useLanguageContext as J } from "../../../temp-lib/contexts/language/LanguageContext.js";
import { usePreloadContext as F } from "../../../temp-lib/contexts/share/PreloadContext.js";
import M from "../../../temp-lib/hooks/generic/useApeironPathMaker.js";
import u from "../../../temp-lib/hooks/json/useFetchJson.js";
import * as t from "ramda";
import { useState as _, useMemo as A, useCallback as C, useEffect as E } from "react";
const y = () => {
  const [p, d] = _(null), { preloadValue: n } = F(), { language: h } = J(), { makePath: c } = M(), e = A(
    () => c(O.Json, s.JSON_FILE_NAME.DOWNLOAD),
    [c]
  ), { fetchJson: r } = u({ url: e }), { fetchJson: m } = u({
    url: s.JSON_FILE_NAME.DOWNLOAD_CONFIG
  }), i = C(async () => {
    const D = async () => Promise.all([r(), m()]), [o, g] = await n(e, D), a = (l) => N.cast(l, {
      context: {
        data: l,
        info: t.propOr({}, "client_version", g)
      }
    }), f = {
      battleDemo: t.map(a, (o == null ? void 0 : o.battleDemo) || []),
      foonieMagus: t.map(a, (o == null ? void 0 : o.battleDemo) || []),
      login: t.map(a, (o == null ? void 0 : o.login) || []),
      officialSite: t.map(a, (o == null ? void 0 : o.officialSite) || [])
    };
    return d(f), f;
  }, [m, r, n, e]);
  return E(() => {
    i();
  }, [h]), {
    data: p,
    fetchJson: i
  };
};
export {
  y as default
};
//# sourceMappingURL=useFetchDownloadMapJson.js.map
